import cn from 'classnames';
import {useState} from 'preact/hooks';
import {Segmented, ArrowSpanBtn, NormalBtn, SubTitle} from './components';

import {useQfScreen, useVisibleVideoPlay} from '../comp/utils/hook';
import styles from '~/style/aigallery/agent.module.less';
import styleCom from '~/style/aigallery/common.module.less';
import {agent as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';
const id = 'agent';
export const TabComponent = props => {
    const {tabsNav, content, className, isGrey} = props.data;
    const {screenWidth} = useQfScreen();
    const [active, setActive] = useState(tabsNav[0].value);
    const cont = content[active];

    useVisibleVideoPlay(screenWidth <= 991 ? 'tab1VideoId_m' : 'tab1VideoId', active, screenWidth <= 991);

    return (
        <div className={styles[`${className}-tabs-nav`]}>
            <Segmented options={tabsNav} isGrey={isGrey} value={active} onChange={setActive} />
            <div
                key={active}
                className={cn(styles['tabs-content'], `${moduleContentCn}`)}
                style={
                    className === 'agent'
                        ? !cont.rightVideo_m
                            ? {
                                  backgroundImage: screenWidth <= 991 ? `url(${cont.m_bg})` : `url(${cont.bg})`,
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: screenWidth <= 991 ? '100% auto' : '100% 100%',
                                  backgroundPosition: screenWidth <= 991 ? 'center bottom' : 'center top',
                                  backgroundClip: 'padding-box'
                              }
                            : {}
                        : {
                              backgroundImage: screenWidth <= 768 ? `url(${cont.m_bg})` : `url(${cont.bg})`,
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: screenWidth <= 768 ? 'cover' : '100% 100%',
                              backgroundPosition: 'center top'
                          }
                }
            >
                <div className={styles['tabs-content-wrap']}>
                    {/* 样式控制 agent模块 screenWidth <= 991 才出现  */}
                    {cont.rightVideo_m && (
                        <video
                            muted
                            autoPlay={cont.videoId_m !== 'tab1VideoId_m'}
                            id={cont.videoId_m || 'video_m'}
                            loop
                            preload="auto"
                            playsinline
                            webkit-playsinline="true"
                            poster={cont.video_poster_m}
                            className={styles['video-ipad']}
                            src={cont.rightVideo_m}
                        ></video>
                    )}
                    <div className={styles.left}>
                        <div className={styles['left-content']}>
                            <h3>{cont.title}</h3>
                            {cont.descArr.map((item, index) => {
                                return (
                                    <div key={index} className={styles['desc-item']}>
                                        <h4>{item.tit}</h4>
                                        <p>{item.des}</p>
                                    </div>
                                );
                            })}
                            <div className={styles['left-btn-wrap']}>
                                <NormalBtn data={{...cont.btns[0], cns: cont.btns[0].type}} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.right}>
                        {cont.rightBg && <img src={cont.rightBg} alt="" />}
                        {/* 样式控制 agent模块 screenWidth > 991 才出现  */}
                        {cont.rightVideo && (
                            <video
                                muted
                                loop
                                autoPlay={cont.videoId !== 'tab1VideoId'}
                                preload="auto"
                                id={cont.videoId || 'video1'}
                                playsinline="true"
                                webkit-playsinline="true"
                                className={styles['video-pc']}
                                poster={cont.video_poster}
                            >
                                <source src={cont.rightVideo} type="video/mp4" />
                            </video>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
const Index = () => {
    const {title, application} = data;

    useCptDuration(id, {
        name: `${applicationName}-构建企业级Agent-停留时长`
    });

    return (
        <div className={cn(styles.agent, styleCom['modules-padding'])} id={id}>
            <h2 className={`${moduleTitleCn}`}>{title}</h2>
            <TabComponent data={data} key="agent" />
            <div className={cn(styles['selected-model'], `${moduleContentCn}`)}>
                <SubTitle data={{subTitle: application.title}} />
                <div className={styles.applications}>
                    {application.list.map((item, index) => (
                        <a
                            key={index}
                            className={cn(styles.card, styles[`bg${index}`], styleCom['box-padding'])}
                            href={item.btns.link}
                            target="_blank"
                            {...item.btns.trackInfo}
                        >
                            <img className={styles.icon} src={item.icon} alt="" />
                            <div className={styles.info}>
                                <h4>{item.title}</h4>
                                <div className={styles['tag-list']}>
                                    {item.tag.map((val, idx) => {
                                        return (
                                            <span key={idx} className={styles.tag}>
                                                {val}
                                            </span>
                                        );
                                    })}
                                </div>
                                <p className={styles.desc}>{item.desc}</p>
                                <div className={styles['btn-wrapper']}>
                                    <ArrowSpanBtn data={{...item.btns, trackInfo: item.btns.trackInfo}} />
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Index;
